import React from 'react';
import Form from 'react-bootstrap/Form';
import { TwitterPicker } from 'react-color';
import RichText from '../controls/RichText';
import { useForceUpdate, getRawText } from '../util';
import { deepMap, hydrate } from '../DataStructures';
import { TabContextReporter } from '../TabContext';
import Dropdown from 'react-bootstrap/Dropdown';
import { Range } from 'slate';
const DEBUG = false;
export default function TaskPassageReveal(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const noReveal = dataProps.noReveal;
  const [collapsed, setCollapsed] = React.useState(true);
  const setPathValue = (path, fun) => {
    DEBUG && console.log("setPathValue", path);
    let activeClickParent = path.slice(0, -1).reduce((p, c) => p.children[c], {
      children: props.data.children
    });
    let activeClickParentChildren = deepMap(JSON.parse(JSON.stringify(activeClickParent.children)), hydrate);
    let activeClick = activeClickParentChildren[path[path.length - 1]];
    fun(activeClick);
    activeClickParent.children = activeClickParentChildren;
  };
  const editorRef = /*#__PURE__*/React.createRef();
  const customEditorRef = /*#__PURE__*/React.createRef();
  let count = 0;
  function renderChildTab(v, k) {
    var _v$children;
    let path = this.slice();
    path.push(k);
    if (v.tagName === "TaskPassageReveal.Passage") {
      var _v$props, _v$props2, _v$props3;
      count++;
      return /*#__PURE__*/React.createElement(TabContextReporter, {
        key: k,
        index: String(count),
        title: "Response: " + count
      }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Response:")), /*#__PURE__*/React.createElement("div", null, getRawText(v))), noReveal && /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Contents:"), " ", /*#__PURE__*/React.createElement("i", null, "Text to be displayed on hover.")), /*#__PURE__*/React.createElement(RichText, {
        value: (_v$props = v.props) === null || _v$props === void 0 ? void 0 : _v$props.contents,
        onChange: val => {
          setPathValue(path, activeClick => {
            activeClick.props.contents = val;
          });
          forceUpdate();
          props.onChanged();
        }
      })), noReveal && /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Hotspot Tooltip Direction:")), /*#__PURE__*/React.createElement(Dropdown, {
        className: "mx-2"
      }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
        id: "dropdown-basic"
      }, (_v$props2 = v.props) === null || _v$props2 === void 0 ? void 0 : _v$props2.placement), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
        onClick: e => {
          setPathValue(path, activeClick => {
            activeClick.props.placement = "right";
          });
          forceUpdate();
          props.onChanged();
        }
      }, "Right"), /*#__PURE__*/React.createElement(Dropdown.Item, {
        onClick: e => {
          setPathValue(path, activeClick => {
            activeClick.props.placement = "left";
          });
          forceUpdate();
          props.onChanged();
        }
      }, "Left"), /*#__PURE__*/React.createElement(Dropdown.Item, {
        onClick: e => {
          setPathValue(path, activeClick => {
            activeClick.props.placement = "top";
          });
          forceUpdate();
          props.onChanged();
        }
      }, "Top"), /*#__PURE__*/React.createElement(Dropdown.Item, {
        onClick: e => {
          setPathValue(path, activeClick => {
            activeClick.props.placement = "bottom";
          });
          forceUpdate();
          props.onChanged();
        }
      }, "Bottom")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Color:")), /*#__PURE__*/React.createElement(TwitterPicker, {
        color: (_v$props3 = v.props) === null || _v$props3 === void 0 ? void 0 : _v$props3.color,
        onChange: c => {
          setPathValue(path, activeClick => {
            activeClick.props.color = c.hex;
          });
          forceUpdate();
          props.onChanged();
        },
        triangle: "hide",
        colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB6F8F', '#F78DA7', '#DABEEF']
      })));
    } else if ((_v$children = v.children) !== null && _v$children !== void 0 && _v$children.map) {
      return v.children.map(renderChildTab, path);
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Passage:"), " ", /*#__PURE__*/React.createElement("i", null, "Use the brush to mark up the text.")), /*#__PURE__*/React.createElement(RichText, {
    value: props.data.children,
    onChange: v => {
      props.data.children = v;
      props.onChanged();
    },
    toolbar: [{
      type: 'Component',
      tagName: 'TaskPassageReveal.Passage',
      title: 'Passage Reveal',
      icon: 'brush',
      variant: 'primary',
      onSelect: console.log
    }],
    editorRef: editorRef,
    customEditorRef: customEditorRef,
    onSelect: e => {
      let editor = editorRef.current;
      let CustomEditor = customEditorRef.current;
      let c = Range.isCollapsed(editor.selection);
      if (c !== collapsed) {
        setCollapsed(c);
      }
      const result = CustomEditor.getActiveTag(editor, "TaskPassageReveal.Passage");
      if (!!result) {
        const [node, path] = result;
      }
    }
  })))), props.data.children && props.data.children.map(renderChildTab, []));
}